import {AbstractSliderQuestionType} from './abstract-slider-question-type';

export class SliderQuestionType extends AbstractSliderQuestionType {

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/questions/slider-question-type.ts